import { render, staticRenderFns } from "./housingResources.vue?vue&type=template&id=1d8a1914&scoped=true&"
import script from "./housingResources.vue?vue&type=script&lang=js&"
export * from "./housingResources.vue?vue&type=script&lang=js&"
import style0 from "./housingResources.vue?vue&type=style&index=0&id=1d8a1914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a1914",
  null
  
)

export default component.exports